export default __webpack_public_path__ + "static/media/bill-of-lading.dad260c2.svg";